import { render, staticRenderFns } from "./DepositHistory.vue?vue&type=template&id=6f76d812&scoped=true"
import script from "./DepositHistory.vue?vue&type=script&lang=js"
export * from "./DepositHistory.vue?vue&type=script&lang=js"
import style0 from "./DepositHistory.vue?vue&type=style&index=0&id=6f76d812&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f76d812",
  null
  
)

export default component.exports